module.exports = __webpack_public_path__ + "img/footer-img.041698c2.png";